export const GET_SURVEYS_REQUEST = 'GET_SURVEYS_REQUEST';
export const GET_SURVEYS_SUCCESS = 'GET_SURVEYS_SUCCESS';
export const GET_SURVEYS_ERROR = 'GET_SURVEYS_ERROR';

export const GET_PROVIDER_SURVEYS_REQUEST = 'GET_PROVIDER_SURVEYS_REQUEST';
export const GET_PROVIDER_SURVEYS_SUCCESS = 'GET_PROVIDER_SURVEYS_SUCCESS';
export const GET_PROVIDER_SURVEYS_ERROR = 'GET_PROVIDER_SURVEYS_ERROR';

export const SURVEY_ADD_TARGETS_REQUEST = 'SURVEY_ADD_TARGETS_REQUEST';
export const SURVEY_ADD_TARGETS_SUCCESS = 'SURVEY_ADD_TARGETS_SUCCESS';
export const SURVEY_ADD_TARGETS_ERROR = 'SURVEY_ADD_TARGETS_ERROR';

export const GET_SURVEY_REQUEST = 'GET_SURVEY_REQUEST';
export const GET_SURVEY_SUCCESS = 'GET_SURVEY_SUCCESS';
export const GET_SURVEY_ERROR = 'GET_SURVEY_ERROR';

export const ADD_SURVEY_REQUEST = 'ADD_SURVEY_REQUEST';
export const ADD_SURVEY_SUCCESS = 'ADD_SURVEY_SUCCESS';
export const ADD_SURVEY_ERROR = 'ADD_SURVEY_ERROR';

export const SURVEY_SAVE_OPTION_REQUEST = 'SURVEY_SAVE_OPTION_REQUEST';
export const SURVEY_SAVE_OPTION_SUCCESS = 'SURVEY_SAVE_OPTION_SUCCESS';
export const SURVEY_SAVE_OPTION_ERROR = 'SURVEY_SAVE_OPTION_ERROR';

export const ASSIGN_SURVEYS_TO_PARTNER_REQUEST = 'ASSIGN_SURVEYS_TO_PARTNER_REQUEST';
export const ASSIGN_SURVEYS_TO_PARTNER_SUCCESS = 'ASSIGN_SURVEYS_TO_PARTNER_SUCCESS';
export const ASSIGN_SURVEYS_TO_PARTNER_ERROR= 'ASSIGN_SURVEYS_TO_PARTNER_ERROR';

export const SURVEYS_ADD_RAW_RESULT_REQUEST = 'SURVEYS_ADD_RAW_RESULT_REQUEST';
export const SURVEYS_ADD_RAW_RESULT_SUCCESS = 'SURVEYS_ADD_RAW_RESULT_SUCCESS';
export const SURVEYS_ADD_RAW_RESULT_ERROR= 'SURVEYS_ADD_RAW_RESULT_ERROR';

export const PROVIDER_CUSTOM_TEMPLATE_REQUEST = 'PROVIDER_CUSTOM_TEMPLATE_REQUEST';
export const PROVIDER_CUSTOM_TEMPLATE_SUCCESS = 'PROVIDER_CUSTOM_TEMPLATE_SUCCESS';
export const PROVIDER_CUSTOM_TEMPLATE_ERROR = 'PROVIDER_CUSTOM_TEMPLATE_ERROR';

export const RRH_CUSTOM_TEMPLATE_REQUEST = 'RRH_CUSTOM_TEMPLATE_REQUEST';
export const RRH_CUSTOM_TEMPLATE_SUCCESS = 'RRH_CUSTOM_TEMPLATE_SUCCESS';
export const RRH_CUSTOM_TEMPLATE_ERROR = 'RRH_CUSTOM_TEMPLATE_ERROR';

export const GET_REPORTING_REQUEST = 'GET_REPORTING_REQUEST';
export const GET_REPORTING_SUCCESS = 'GET_REPORTING_SUCCESS';
export const GET_REPORTING_ERROR = 'GET_REPORTING_ERROR';
